import React from 'react'
import { useRouter } from 'next/router'
import queryTypes from './queryTypes'

function useQueryState(key, { defaultValue = '', type = 'string' }) {
  const router = useRouter()
  const queryTypeHandler = queryTypes[type]
  const [filter, setFilter] = React.useState(defaultValue)
  const setQueryFilter = (value) => {
    if (router.query[key] !== queryTypeHandler.serialize(value)) {
      router.query[key] = queryTypeHandler.serialize(value)
      router.push(router, null, { shallow: true })
    }
  }
  React.useEffect(() => {
    setFilter(queryTypeHandler.parse(router.query[key], defaultValue))
  }, [queryTypeHandler.serialize(router.query[key])])
  return [filter, setQueryFilter]
}

export default useQueryState
